<template>
  <div class="normal">
    <div class="aui-book-head" v-if="title">
      <h2>{{title}}</h2>
      <div>
        <a v-if="showRefresh" class="ccc" @click="showRefreshAction">换一批</a>
        <span  v-if="showMore"  @click="showMoreAction" class="more">更多</span>
      </div>
    </div>
    <div class="slide-list">
      <router-link :to="{name: 'novel-home', params: {id: book.bookId}}" v-for="book in books" :key="book.bookId"  class="slide-list-item">
        <div class="aui-list-img">
         <img imgtype="novel" :bookid="book.bookId" :booktitle="book.title" :chapternum="0" :imgpath="book.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
           <h3>{{book.title}}</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <!-- <span class="i-a">{{book.categoryName}}</span> -->
              <span v-if="book.publishStatus==='serialize'" class="i-r">连载中</span>
              <span v-if="book.publishStatus==='finish'" class="i-b">已完结</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'books-small',
  props: {
    title: String,
    books: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {}
  },
  methods: {
    toBookDetail (id) {
      this.$router.isBack = false
      this.$router.push(`/novel/${id}`)
    },
    showMoreAction () {
      this.$emit('show-more')
    },
    showRefreshAction(){
      this.$emit('show-refresh');
    },
    getPublishStatusText (code) {
      if (code === 'finish') {
        return '完结'
      } else {
        return '连载'
      }
    }
  },
  watch: {
    books (data) {}
  }
}
</script>

<style scoped>

@import "../../assets/css/novel.css";

.aui-book-head .ccc{padding:0 0.3rem 0 1.4rem; line-height: 1.2rem; height: 1.2rem; font-size: .6rem; border-radius: 1rem;  display: inline-block;
  background:#333 url(../../assets/images/i7.png) 0.4rem center no-repeat; background-size: 0.7rem; color: #e99d18; margin-right: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/novel/books-small.vue